import {Modal,message} from "antd"
import RegisterPDF from "../../../Layouts/PDF/Register/RegisterPDF"
import { useCallback } from "react"
import InstituteService from "../../../../services/InstituteService"

export default function RegisterPermissionLetterInstitute(props) {
    const {propsModal,propsOptions,propsInstitute,propsIsUploadPDF,propsModalOption,propsDataUpdate}=props
    const propsRegister={
        registerPDF:(data)=>createPermissionLetterCenter(data),

    }
    const createPermissionLetterCenter=useCallback((data)=>{
        let document=data;
        console.log(document)
        const formData = new FormData();
        Object.entries(document).forEach(([key, value]) => {
            formData.append(key, value);
          });
          if(document.documentApprovalAttachment!==undefined){
            let blob = new Blob([document.documentApprovalAttachment.fileList[0].originFileObj] , { type: "application/pdf" });
            console.log("blob",blob)
            //objectUrl = URL.createObjectURL(blob);
            //console.log("objectUrl",objectUrl)
            formData.set("documentApprovalAttachment",blob,document.documentApprovalAttachment.fileList[0].originFileObj.name);
          }
       
        if(propsModalOption==="create"){
            InstituteService.createDocumentApproval(formData,propsInstitute.id,propsInstitute.User.id).then((res)=>{
                if(res.data?.success){
                    message.success("Se subio el archivo de forma correcta")
                    propsIsUploadPDF(true)
                }else{
                    message.error("Hubo un problema para subir el archivo")
                }
            })
           }
           else if(propsModalOption==="update"){
            InstituteService.updateDocumentApproval(formData,propsInstitute.id,propsInstitute.User.id).then((res)=>{
                if(res.data?.success){
                    message.success("Se actualizo el archivo de forma correcta")
                    propsIsUploadPDF(true)
                }else{
                    message.error("Hubo un problema para actualizar el archivo")
                }
            })
           }
    })
    
    return(
        <>
        <Modal
        {...propsModal}
        >
            <RegisterPDF 
            {...propsOptions} 
            propsRegister={propsRegister}
            dataUpdate={propsDataUpdate}
            ></RegisterPDF>
        </Modal>
        </>
    )
}